import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledTopBanner = styled.div`
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-top: -90px;

    ${media.xs(css`
        min-height: 100vh;
        min-height: -webkit-fill-available;
        min-height: fill-available;
    `)};

    ${media.sm(css`
        height: 100vh;
    `)};

    ${media.md(css`
        height: 100vh;
    `)};

    ${media.lg(css`
        height: 100vh;
    `)};
`;

export const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    height: inherit;
    padding-top: 90px;

    ${media.sm`
        align-items: center;
    `}

    ${media.md`
        align-items: flex-start;
    `}
`;

export const StyledContent = styled.div`
    position: relative;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    flex: 1;

    ${media.md`
        padding-top: 125px;
    `}
`;

export const StyledInfoBlock = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 22px;
    min-height: 290px;
    margin: 20px 20px 0 20px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.02);
    backdrop-filter: blur(8px);

    button {
        &:first-child {
            margin-right: 12px;
        }
    }

    ${media.sm`
        min-height: 375px;
        max-width: 460px;
        padding: 24px;
        gap: 26px;
    `}

    ${media.md`
        max-width: 548px;
        min-height: 375px;
        padding: 40px 40px 48px 40px;

        button {
            width: 177px;
        }
    `}
`;

export const StyledDescription = styled(Typography)`
    margin-top: 15px;

    ${media.md`
        margin-top: 24px;
    `}
`;

export const StyledImg = styled.img`
    z-index: 1;
    max-width: 100%;
    position: relative;
    top: 0;
    right: 0;
    height: auto;
    width: 100%;

    ${media.sm`
        position: absolute;
        height: 100%;
        width: auto;
    `}
`;

export const StyledCanvas = styled.div`
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-color: #100c15;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const StyledButtonsWrapper = styled(FlexBox)`
    margin-top: 60px;
    gap: 10px;

    ${media.sm`
        margin-top: 0;
    `};
`;

export const StyledLoader = styled.div`
    position: absolute;
    top: 60%;
    left: 40%;

    ${media.md`
        top: calc(40%);
        left: calc(50%);
    `}
`;